import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Parameters } from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: any, option) {
    const parameters: Parameters = {
      ...option,
    };

    let options: AbstractControlOptions = {};

    const form = this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userLastName: [entity?.userLastName || null],
        userFirstName: [entity?.userFirstName ? entity.userFirstName : null],
        personnesInCharge: [
          !_.isNil(entity?.personnesInCharge)
            ? entity?.personnesInCharge
            : null,
          [Validators.required],
        ],
      },
      options,
    );

    return form;
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }

  extract() {
    return this.form.value.owners;
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
}
